(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jg-flip-board"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.flip-card').forEach((card) => {
      card.addEventListener('click', function () {
        if (window.innerWidth < 768) {
          this.querySelector('.flip-inner').classList.toggle('flipped');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
